import { Link } from "react-router-dom";
import NavBar from './NavBar/NavBar.module.css'
import { Typography } from "@mui/material";

const Navlink = ({ isClicked, closeMenu}) => {
    return(
    <nav className={NavBar["NavLinks"]}>
        <ul>
            <li >
                <Link to='/' onClick={closeMenu}>
                    <Typography sx={{typography: {xs: 'body1', sm: 'body1', md: 'h6', lg: 'h6', xl: 'h6'} }} color="orange">HOME</Typography>
                </Link>
            </li>
            <li >
                <Link to='/host' onClick={closeMenu}>
                <Typography sx={{typography: {xs: 'body1', sm: 'body1', md: 'h6', lg: 'h6', xl: 'h6'} }} color="orange">HOST</Typography>
                </Link>
            </li>
            <li >
                <Link to='/bloglist' onClick={closeMenu}>
                    <Typography sx={{typography: {xs: 'body1', sm: 'body1', md: 'h6', lg: 'h6', xl: 'h6'} }} color="orange">BLOG</Typography>
                </Link>
            </li>
            <li >
                <Link to='/about' onClick={closeMenu}>
                    <Typography sx={{typography: {xs: 'body1', sm: 'body1', md: 'h6', lg: 'h6', xl: 'h6'} }} color="orange">ABOUT</Typography>
                </Link>
            </li>
        </ul>            
            

    </nav>
    )
};


export default Navlink;